import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Select2OptionData } from 'ng2-select2';

import swal from 'sweetalert2';
import { SessionService } from '../../services/session.service';
import { ContractService } from '../../services/contract.service';
import { CacheService } from '../../models/cache-service.model';
import { UserService } from '../../services/user.service';

declare var jQuery: any;

@Component({
  selector: 'app-layout-btn-floating',
  templateUrl: './layout-btn-floating.component.html',
  styleUrls: ['./layout-btn-floating.component.css']
})
export class LayoutBtnFloatingComponent implements OnInit {

  public contracts: any[];

  constractsVisible: boolean;

  public selected: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _contractService: ContractService,
    private _sessionService: SessionService,
    private _userService: UserService
  ) { }

  ngOnInit() {

    this.constractsVisible = false;

    let _contracts = this._sessionService.getContracts();

    if (_contracts === undefined) {
      this.constractsVisible = false;
    } else {
      if (_contracts.length > 1) {
        this.constractsVisible = true;
      }
    }
  }

  toggle() {

    jQuery('#help-actions').addClass('active');

  }

  private closeSidebar() {
    jQuery('.app-sidebar').removeClass('active');
    jQuery('.app-container').removeClass('__sidebar');
  }

  contratos() {
    this.closeSidebar();

    this.contracts = this._sessionService.getContracts();

    var _array = [];

    for (let c of this.contracts) {
      let _obj = {
        id: c.id,
        name: c.text
      };
      _array.push(_obj);
    }

    var options = {};
    $.map(_array,
      function (o) {
        options[o.id] = o.name;
      });

    swal({
      width: 400,
      showCloseButton: true,
      imageClass: 'imgLogo',
      imageUrl: './assets/images/logo.png',
      imageWidth: 150,
      html: `<div style="text-align: center">
             <h3 style="color: #1d7bbb;">Cambio de Contrato</h3>
             <br/>
             <p style="font-size:14px">Seleccione uno de los contratos registrados y presione el botón continuar.</p>`,
      animation: true,
      allowOutsideClick: false,
      input: 'select',
      inputOptions: options,
      inputPlaceholder: 'Seleccione un contrato...',
      confirmButtonClass: 'btn btn-success btn-confirm-modal',
      confirmButtonText: 'Continuar',
      showCancelButton: true,
      cancelButtonClass: 'btn btn-info',
      cancelButtonText: 'Cancelar',
      buttonsStyling: false,
      focusConfirm: false,
      onOpen: () => {
        jQuery(".swal2-select").css('text-align', 'center');
        jQuery(".swal2-select").select2();
      },
      inputValidator: (value) => {
        return new Promise((resolve) => {
          if (value !== '') {

            let _contract = jQuery(".swal2-select").val();
            this._sessionService.setCache(new CacheService());//borramos cache
            this._sessionService.setSelectContract(_contract);

            for (let _Contract of this._sessionService.getContracts()) {

              if (_Contract.id === _contract) {
                this._sessionService.setSelectDocumentTypeContracted(_Contract.documentType);
              }
            }

            //busco datos de usuario

            let _user = this._sessionService.getCurrentUser();

            this._userService.getDataUserForContract(_user.user, _contract).subscribe(
              res => {

                let _user = this._sessionService.getCurrentUser();
                _user.age = res.age;
                _user.birthDate = res.birthDate;
                _user.contractNumber = res.contractNumber;
                _user.documentId = res.documentId;
                _user.name = res.name;
                this._sessionService.setCurrentUser(_user);
                this._sessionService.setCache(new CacheService());

                this._userService.isUpdateData({ user: this._sessionService.getCurrentUser().user, contractNumber: _contract }).subscribe(
                  res => {

                    let _user = this._sessionService.getCurrentUser();
                    _user.actualizacionMenu = res;
                    this._sessionService.setCurrentUser(_user);

                    this._contractService.getDataContract(_contract).subscribe(
                      res => {
                        this._sessionService.setDataContract(res, true);
                        this.router.navigate(['/office/home']).then(() => {
                          window.location.reload();
                        });
                        resolve();
                      },
                      err => {
                        console.log(err);
                        resolve('Se ha presentado un error. intente nuevamente');
                      }
                    );

                  },
                  err => {
                    console.log(err);
                    resolve('Se ha presentado un error. intente nuevamente');
                  }
                );

              },
              err => {
                swal({
                  title: 'Selección de Contrato',
                  html: '<p style="font-size:14px">Ocurrio un inconveniente. por favor intente nuevamente</p>',
                  type: 'warning',
                  confirmButtonClass: 'btn btn-primary',
                  buttonsStyling: false,
                  focusConfirm: false
                });
              }
            );

          } else {
            resolve('Debe seleccionar un contrato')
          }
        })
      },
    });

  }

  miPerfil() {
    this.router.navigate(['/office/profile']);
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/layout-btn-floating/layout-btn-floating.component.ts